import { SIGNAGE_CATALOG_TYPE } from "@constants"

export default {
  home: {
    table: {
      header: {
        id: "店舗ID",
        name: "店舗名",
        device: "端末",
      },
      deviceLink: "端末一覧の確認",
    },
    button: {
      setting: "表示の設定",
    },
  },
  device: {
    title: "端末一覧",
    table: {
      header: {
        code: "端末ID",
        name: "デバイス名",
        address: "設置場所",
        store_name: "店舗名",
        printer_name: "プリンター名",
        ip_address: "プリンターIP",
        actions: "アクション",
      },
    },
  },
  advertisement: {
    title: "広告/販促枠",
    mediaUpload: {
      note: "※登録できる画像・動画形式は「JPG, PNG, JPEG, WEBP, MP4, MOV」です。5MB以内の画像と50MB以内の動画を登録してください。",
    },
    label: {
      duration: "イメージ表示時間（秒）",
    },
    button: {
      submit: "保存",
    },
  },
  catalog: {
    button: {
      add: "新規カテゴリーの追加",
    },
    type: {
      label: "種別",
      placeholder: "種別を選択",
      value: {
        [SIGNAGE_CATALOG_TYPE.MAKER]: "メーカー",
        [SIGNAGE_CATALOG_TYPE.RANKING]: "ランキング",
        [SIGNAGE_CATALOG_TYPE.TAG]: "タグ",
      },
    },
    reference: {
      label: "カテゴリー",
      placeholder: "カテゴリーを選択",
    },
    input: {
      placeholder: "{name}を入力してください",
    },
    table: {
      header: {
        display_order: "表示順番",
        catalog_type: "種別",
        reference_id: "カテゴリー",
        display_name: "表示名称",
        slogan: "販促フレーズ",
        isEdit: "アクション",
      },
    },
  },
}
